import styles from './index.module.css'

import React from 'react'

import { useTranslation } from '@disco/i18n/use-translation'

import { Box, Separator as RadixSeparator } from 'components/ds'

type Props = {
  or?: boolean
}

/**
 * Separator component for login form sections with optional 'OR' text
 * Provides visual separation between different login methods
 * @param or - Whether to display 'OR' text in the separator
 */
const Separator = ({ or }: Props): React.ReactNode => {
  const { t } = useTranslation('accounts')

  if (!or) {
    return (
      <RadixSeparator size="4" mt="4" mb="4" className={styles.Separator} />
    )
  }

  return (
    <Box position="relative" mt="4" mb="4">
      <RadixSeparator size="4" className={styles.Separator} />
      <span className={styles.Separator_OrLabel}>{t('accounts:or', 'or')}</span>
    </Box>
  )
}

export default Separator
